var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Room',{attrs:{"items":_vm.items,"positions":_vm.mockedPosition,"room-size":[30, 10, 30],"background-video":"self-emptiness/IMG_1915.MOV"}})}
var staticRenderFns = []

export { render, staticRenderFns }